import { render, staticRenderFns } from "./AllGamesPage.vue?vue&type=template&id=3b36b642"
import script from "./AllGamesPage.vue?vue&type=script&lang=js"
export * from "./AllGamesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports